import { useCallback, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { useLanguage } from '../../i18n';
import { usePrefersReducedMotion } from '../../hooks/useMediaQuery';
import { hgroupNegro } from '../../assets/images/logo';
import './Navbar.scss';

const MENU_ITEMS = [
  { id: 'servicios', key: 'nav.servicios' },
  { id: 'proyectos', key: 'nav.proyectos' },
  { id: 'colaboraciones', key: 'nav.colaboraciones' },
  { id: 'contacto', key: 'nav.contacto' },
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();
  const reduceMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (reduceMotion) return;
    gsap.fromTo(
      '.navbar',
      { y: -100, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out' },
    );
  }, [reduceMotion]);

  const scrollToSection = useCallback((event, sectionId) => {
    event.preventDefault();
    const section = document.getElementById(sectionId);
    if (!section) return;
    section.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  }, []);

  const handleLogoClick = useCallback((event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  }, []);

  return (
    <nav className="navbar" aria-label="Principal">
      <div className="navbar__container container">
        <a
          href="#hero"
          className="navbar__logo"
          onClick={handleLogoClick}
          aria-label="H Group — ir al inicio"
        >
          <img src={hgroupNegro} alt="H Group" />
        </a>

        <ul
          id="primary-menu"
          className={`navbar__menu ${isMobileMenuOpen ? 'navbar__menu--open' : ''}`}
        >
          {MENU_ITEMS.map((item) => (
            <li key={item.id} className="navbar__menu-item">
              <a
                href={`#${item.id}`}
                onClick={(event) => scrollToSection(event, item.id)}
              >
                {t(item.key)}
              </a>
            </li>
          ))}
        </ul>

        <div className="navbar__actions">
          <button
            type="button"
            className="navbar__lang-toggle"
            onClick={toggleLanguage}
            aria-label={language === 'es' ? 'Switch to English' : 'Cambiar a español'}
          >
            {language === 'es' ? 'EN' : 'ES'}
          </button>

          <button
            type="button"
            className={`navbar__hamburger ${isMobileMenuOpen ? 'navbar__hamburger--open' : ''}`}
            onClick={() => setIsMobileMenuOpen((open) => !open)}
            aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="primary-menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
